module.exports = __webpack_public_path__ + "img/CIO110_R.0f973600.png";